import React, { useRef, useImperativeHandle, forwardRef, useState } from "react";
import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const getYouTubeEmbedUrl = (url) => {
    try {
        const parsed = new URL(url);
        if (parsed.hostname === "youtu.be") {
            return `https://www.youtube.com/embed/${parsed.pathname.slice(1)}?autoplay=1`;
        }
        if (parsed.hostname.includes("youtube.com") && parsed.searchParams.has("v")) {
            return `https://www.youtube.com/embed/${parsed.searchParams.get("v")}?autoplay=1`;
        }
    } catch (_) {}
    return null;
};

const FullscreenVideoPopup = forwardRef((props, ref) => {
    const [open, setOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const videoRef = useRef(null);

    useImperativeHandle(ref, () => ({
        showURL(url) {
            setVideoUrl(url);
            setOpen(true);
        },
    }));

    const handleClose = () => {
        console.log("Closing video popup");
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
        setOpen(false);
        setVideoUrl("");
    };

    const youtubeEmbedUrl = getYouTubeEmbedUrl(videoUrl);

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                onClick={handleClose}
                sx={{
                    position: "fixed",
                    inset: 0,
                    bgcolor: "rgba(0,0,0,0.7)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 16,
                        right: 16,
                        color: "white",
                        bgcolor: "rgba(255,255,255,0.4)",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
                        zIndex: 1,
                    }}
                >
                    <CloseIcon fontSize="large" />
                </IconButton>

                <Box sx={{
                    width: "100%", height: "100%", padding: "5%",
                    inset: 0,
                    bgcolor: "rgba(0,0,0,0.7)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }} onClick={handleClose}>
                    <Box
                        onClick={(e) => e.stopPropagation()}
                        sx={{ width: "100%", height: "100%", boxSizing: "border-box" }}
                    >
                        {youtubeEmbedUrl ? (
                            <iframe
                                src={youtubeEmbedUrl}
                                allow="autoplay; encrypted-media"
                                allowFullScreen
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "none",
                                    display: "block",
                                }}
                                title="YouTube video"
                            />
                        ) : (
                            <video
                                ref={videoRef}
                                src={videoUrl}
                                controls
                                autoPlay
                                controlsList="nofullscreen nodownload noremoteplayback"
                                disablePictureInPicture
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    outline: "none",
                                    display: "block",
                                }}
                            />
                        )}
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
});

export default FullscreenVideoPopup;
